import BackButtonIcon from 'designSystem/icons/Iconography/BackButton';
import BackgroundLightIcon from 'designSystem/icons/Iconography/BackgroundLight';
import BigInfoIcon from 'designSystem/icons/Iconography/BigInfoIcon';
import BookIcon from 'designSystem/icons/Iconography/BookIcon';
import CalendarIcon from 'designSystem/icons/Iconography/CalendarIcon';
import CheckMarkIcon from 'designSystem/icons/Iconography/CheckMarkIcon';
import ChevronDownIcon from 'designSystem/icons/Iconography/ChevronDownArrow';
import CircleExclamationIcon from 'designSystem/icons/Iconography/CircleExclamationIcon';
import ClockIcon from 'designSystem/icons/Iconography/ClockIcon';
import CloseIcon from 'designSystem/icons/Iconography/CloseIcon';
import CoinIcon from 'designSystem/icons/Iconography/CoinIcon';
import ContentGuidelinesIcon from 'designSystem/icons/Iconography/ContentGuidelinesIcon';
import DownloadIcon from 'designSystem/icons/Iconography/DownloadIcon';
import ErrorIcon from 'designSystem/icons/Iconography/ErrorIcon';
import Headphone2Icon from 'designSystem/icons/Iconography/Headphone2Icon';
import HeadphoneIcon from 'designSystem/icons/Iconography/HeadphoneIcon';
import InwardArrowIcon from 'designSystem/icons/Iconography/InwardArrowIcon';
import MobileInfoIcon from 'designSystem/icons/Iconography/MobileInfoIcon';
import MoneyIcon from 'designSystem/icons/Iconography/MoneyIcon';
import NewHeadphoneIcon from 'designSystem/icons/Iconography/NewHeadphoneIcon';
import NewPencilIcon from 'designSystem/icons/Iconography/NewPencilIcon';
import NotebookIcon from 'designSystem/icons/Iconography/NoteBook';
import NovelDarkIcon from 'designSystem/icons/Iconography/NovelDarkIcon';
import OutwardArrowIcon from 'designSystem/icons/Iconography/OutwardArrowIcon';
import PocketNovelIcon from 'designSystem/icons/Iconography/PocketNovelIcon';
import RefreshIcon from 'designSystem/icons/Iconography/RefreshIcon';
import SaveIcon from 'designSystem/icons/Iconography/SaveIcon';
import SuccessIcon from 'designSystem/icons/Iconography/SuccessIcon';
import ViewIcon from 'designSystem/icons/Iconography/ViewIcon';
import ZoomInIcon from 'designSystem/icons/Iconography/ZoomInIcon';
import ZoomOutIcon from 'designSystem/icons/Iconography/ZoomOutIcon';
import { IconographyNameType, IconPropsType } from 'designSystem/types/icons';

const ICONOGRAPHY: Record<
  IconographyNameType,
  (props: IconPropsType) => JSX.Element
> = Object.freeze({
  'background-light': BackgroundLightIcon,
  download: DownloadIcon,
  save: SaveIcon,
  'content-guidelines': ContentGuidelinesIcon,
  check: CheckMarkIcon,
  'big-info-icon': BigInfoIcon,
  close: CloseIcon,
  success: SuccessIcon,
  error: ErrorIcon,
  'headphone-icon': HeadphoneIcon,
  'headphone2-icon': Headphone2Icon,
  'novel-dark-icon': NovelDarkIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
  refresh: RefreshIcon,
  'inward-arrow': InwardArrowIcon,
  'outward-arrow': OutwardArrowIcon,
  'back-button': BackButtonIcon,
  'mobile-info-icon': MobileInfoIcon,
  'view-icon': ViewIcon,
  'clock-icon': ClockIcon,
  'circle-exclamation-icon': CircleExclamationIcon,
  notebook: NotebookIcon,
  calendar: CalendarIcon,
  'pocket-novel': PocketNovelIcon,
  'pencil-icon': NewPencilIcon,
  'new-headphone': NewHeadphoneIcon,
  'chevron-down': ChevronDownIcon,
  money: MoneyIcon,
  coin: CoinIcon,
  book: BookIcon,
});

export default ICONOGRAPHY;
